// extracted by mini-css-extract-plugin
export default {"grid":"galleryGridLayout_grid__NQ86H"};